'use client'
import useAirlineFilterManager from '@/src/hooks/srp/airlineFilterManager'
import { DeviceType } from '@/src/types/deviceType'
import { AirlinesFilter } from './AirlinesFilter'

interface AirlinesFilterWrapperSideBarProps {
    deviceType: DeviceType
}

const AirlinesFilterWrapperSideBar = ({ deviceType }: AirlinesFilterWrapperSideBarProps) => {
    const { airlines, handleSelectToggle, handleReset, handleResetAllJourneys, shouldShowReset, shouldShowResetForAllJourneys, isMulticity, title } = useAirlineFilterManager(0)

    return (
        <AirlinesFilter
            airlines={airlines}
            onAirlineSelect={id => handleSelectToggle(id, 'FilterWrapperSideBar')}
            onReset={isMulticity ? handleResetAllJourneys : handleReset}
            shouldShowReset={isMulticity ? shouldShowResetForAllJourneys : shouldShowReset}
            title={title}
            deviceType={deviceType}
        />
    )
}

export { AirlinesFilterWrapperSideBar }
export default AirlinesFilterWrapperSideBar
